"use client";

import { HowItWorksSection } from "@/components/sections/how-it-works";
import { howItWorks } from "@/lib/data/services-competitive-intelligence";

export function HowItWorks() {
  return (
    <HowItWorksSection
      eyebrow={howItWorks.eyebrow}
      title={howItWorks.title}
      accent={howItWorks.accent}
      stepAccents={howItWorks.stepAccents}
      steps={howItWorks.steps}
    />
  );
}